module.exports = __webpack_public_path__ + "static/img/s137.b651bc20.png";